export default class ResetPasswordRequest {
    email: string;
    newPassword: string;
    passwordResetToken: string;
}